export class ProcessSocialLoginPostRedirectWorkflow {
  static readonly type = '[Social Login Redirect] ProcessSocialLoginPostRedirectWorkflow';

  constructor() {
  }
}
